export default __webpack_public_path__ + "static/media/tictactoe.0f64f577.svg";